<template>
    <section class="section_novel">
        <h2 class="section--title text-center"><strong>Novel</strong></h2>

        <div class="section_novel--main">
            <div class="grid-container">
                <div class="grid-x grid-padding-x align-center">
                    <section class="cell small-12 medium-10">
                        <ul class="grid-x grid-padding-x">
                            <li class="cell small-12 large-6">
                                <article class="novel_article grid-x grid-padding-x align-center">
                                    <figure class="novel_article--image cell small-6 medium-4 small-order-2 medium-order-1">
                                        <img :src="item.image" :alt="item.nameKanji">
                                    </figure>
                                    <section class="cell small-12 medium-8 small-order-1 medium-order-2">
                                        <h3 class="novel_article--title" v-html="item.name"></h3>
                                    </section>
                                    <div class="cell small-12 small-order-3 medium-order-3">
                                        <p class="novel_article--content" v-html="item.description"></p>
                                        <div class="novel_article--book grid-x">
                                            <figure class="novel_article--book--cover cell shrink">
                                                <img :src="item.book_cover" :alt="item.book_title">
                                            </figure>
                                            <section class="cell auto">
                                                <h4 class="novel_article--book--title">{{item.book_title}}</h4>
                                                <p class="novel_article--book--content" v-html="item.book_content"></p>
                                            </section>
                                        </div>
                                    </div>
                                </article>
                            </li>
                            <li class="cell small-12 large-6">
                                <section class="comment_article">
                                    <h3 class="comment_article--title"><img src="/netemosametemo/static/img/comment.png" alt="Comment"><strong class="seo">Comment</strong></h3>
                                    <p class="comment_article--content" v-html="item.comment"></p>
                                </section>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'novel',
    data () {
        return {
            item: {
                nameKanji: '原作：柴崎友香',
                name: 'TOMOKA SHIBASAKI<strong><span>原作：</span>柴崎友香</strong><small>（しばさき・ともか）</small>',
                description: '1973年10月20日、大阪府生まれ。<br>99年の短編「レッド、イエロー、オレンジ、オレンジ、ブルー」が文藝別冊に掲載されデビュー。<br>2000年、初の単行本「きょうのできごと」が刊行され、03年に行定勲監督により映画化される。07年「その街の今は」で第57回芸術選奨文部科学大臣新人賞、第23回織田作之助賞大賞、第24回咲くやこの花賞を受賞。10年に発表し、本作の原作となった小説「寝ても覚めても」で第32回野間文芸新人賞を受賞。14年「春の庭」は第151回芥川龍之介賞を受賞する。その他の著書に「星のしるし」、「主題歌」、「わたしがいなかった街で」、「週末カミング」、「星よりひそかに」、「パノララ」など。最新刊に「千の扉」。16年に、アイオワ大学のインターナショナル・ライティング・プログラム（IWP）に参加。「春の庭」は翻訳本が５カ国で刊行され、今後も２カ国で刊行予定など国際的にも活躍している。',
                comment: '見ているものを書きたい、と思った。<br>見ているもの、見えるもの。<br>目の前にあるもの。<br>たぶん、それをわたしたちはよく見ていないから。目には映っているのに、よくわかっていない。そこにちゃんとあるのに、見過ごしている。だから、書こうとした。<br>誰かのことをどうしようもないほど想うとき、人からその理由を問われて、なんて答えるか。たとえば、こんなことを言ってくれてうれしかったから、と答えたとして、それでは別の誰かが同じことを同じときに言ったらどうだった？ その人でならなければならない理由、他の誰も代わりにはなれはしない理由。言葉にした途端に、離れていってしまう。<br>大切なものや、かけがえのない時間を、わたしたちは写真に撮って確かめ、残そうとする。時間が過ぎること、目の前にあるものが移ろいゆくことを知っているから。時間を経験するのは、自分だけではない。人も、風景も、世界も、等しく動いていく。人はその時間の移ろい＝過去とともに生きていて、だからこそ、自分の経験してきた時間にとらわれてもいる。その重さゆえに、「今」が見えにくくなることがある。<br>それを打ち破って踏み出すような瞬間が、ごくまれに、訪れる。走り出さなければならないときが。<br>映画は、見るものだ。それは徹底して、なにかが映っている。<br>映画『寝ても覚めても』には、この小説を書いている長い時間に考えていたことが、映っていて、わたしはそれを見た。',
                image: '/netemosametemo/static/img/shibasaki_img.jpg',
                book_cover: '/netemosametemo/static/img/novel_img.jpg',
                book_title: '「寝ても覚めても」増補新版',
                book_content: '河出文庫／344ページ<br>発売中／定価799円（本体740円）<br>★小説：柴崎友香×マンガ：森泉岳士<br>　書き下ろしコラボ「同じ街の違う夜」収録'
            }
        }
    },

    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Novel.vue